import gql from 'graphql-tag';

const CREATE_SLA_CONFIG = gql`
  mutation createSlaConfig($data: SlaConfigCreateInput!) {
    createSlaConfig(data: $data) {
      id
      requestType
      recommendedDays
      createdAt
      updatedAt
    }
  }
`;

export default CREATE_SLA_CONFIG;
